import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Card from "./Card.jsx";
import { IoMdClose } from "react-icons/io";
import api from "../../utils/api.js";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import { showCustomAlert } from "../User/Signup/Toast.jsx";
Modal.setAppElement("#root");

const Blog = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState(""); // State for email input
  const [submitting, setSubmitting] = useState(false); // Submitting state

  // Toggle modal visibility
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Fetch blogs
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const response = await api.get("/blog-post");
        setBlogs(response.data.results);
      } catch (error) {
        console.error("Error fetching blog data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const handleSubscribe = async () => {
    console.log("trigger");
  
    if (!email) {
       showCustomAlert({
            title: 'Error',
            html: '<p style="color: #555;">Please enter your email!</p>',
            icon: 'error',
            confirmButtonText: 'ok',
            confirmButtonColor: '#af313d',
            background: '#ffffff',
            timer: 125000,
          });
      // toast.success("Please enter your email!", {
      //   style: {
      //     backgroundColor: "white", // Background color
      //     color: "#AD343E", // Text color
      //   },
      //   icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
      // });
      return;
    }
  
    setSubmitting(true);
    try {
      const response = await api.post("/newsletter/subscribe", { email }); // Replace '/subscribe' with your actual endpoint
      console.log("🚀 ~ handleSubscribe ~ response:", response);
      showCustomAlert({
        title: 'Subscribed successfully',
        html: '<p style="color: #555;">Thank You for Subscription!</p>',
        icon: 'success',
        confirmButtonText: 'ok',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
        timer: 125000,
      });
      // toast.success("Subscribed successfully!", {
      //   style: {
      //     backgroundColor: "white", // Background color
      //     color: "#AD343E", // Text color
      //   },
      //   icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
      // });
      setEmail(""); // Clear email input
      setIsModalOpen(false);
    } catch (error) {
      setIsModalOpen(false);
      console.error("Error subscribing:", error);
  
      // Check if the error message is "Email is already subscribed"
      if (error.response && error.response.data && error.response.data.message === "Email is already subscribed") {
        showCustomAlert({
          title: 'Subscribed Already',
          html: '<p style="color: #555;">This email is already subscribed!</p>',
          icon: 'success',
          confirmButtonText: 'ok',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
          timer: 125000,
        });
        // toast.success("This email is already subscribed.", {
        //   style: {
        //     backgroundColor: "white", // Background color
        //     color: "#AD343E", // Text color
        //   },
        //   icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
        // });
      } else {
        showCustomAlert({
          title: 'Error',
          html: '<p style="color: #555;">Failed to subscribe. Please try again!</p>',
          icon: 'error',
          confirmButtonText: 'ok',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
          timer: 125000,
        });
        // toast.success("Failed to subscribe. Please try again.", {
        //   style: {
        //     backgroundColor: "white", // Background color
        //     color: "#AD343E", // Text color
        //   },
        //   icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
        // });
      }
    } finally {
      setSubmitting(false);
    }
  };
  const categorizedBlogs = blogs.reduce((acc, blog) => {
    const { category } = blog;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(blog);
    return acc;
  }, {});
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <FaSpinner className="animate-spin text-4xl text-[#AF313D] " />
      </div>
    );
  }

  return (
    <div className="min-h-screen mb-16">
      {/* Header Section */}
      <div className="w-full h-[146px] bg-[#AF313D]  flex justify-center items-center text-center text-white">
        <h1 className="font-bold text-[40px] sm:text-[60px]">Blogs</h1>
      </div>

      {/* Button Section */}
      <div className="flex justify-end mt-10 px-4">
        <button
          onClick={toggleModal}
          className="bg-[#AF313D] text-white w-[121px] h-[48px] px-4 py-2 rounded text-sm font-medium hover:bg-red-700"
        >
          <span className="body font-semibold text-[20px] leading-[24px] tracking-[2px]">
          Subscribe
          </span>
        </button>
      </div>

      {/* Modal Component */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="Update Information Modal"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        className="bg-white w-[90%] sm:w-[90%] lg:w-[60%] md:w-[70%] p-6 rounded-lg shadow-lg relative"
      >
        {/* Close button */}
        <button
          onClick={toggleModal}
          className="absolute top-2 right-2 bg-black text-white rounded-full p-1 hover:bg-gray-700 focus:outline-none"
          aria-label="Close modal"
        >
          <IoMdClose size={20} />
        </button>
        <div className="flex flex-col justify-center items-center">
          <h1 className=" body font-bold text-[44.8px] lg:text-[80px] md:text-[67.5px] tracking-[.28px] lg:tracking-[2px] text-[#AF313D]">
            SUBSCRIBE
          </h1>
          <p className=" pt-0 mt-0 font-medium body text-[22.4px] lg:text-[40px] md:text-[33.7px] tracking-[0.5px] text-[#000000]">
            TO OUR NEWSLETTERS
          </p>
          <p className=" w-full flex justify-center items-center text-center p-6 body text-[11.2px] lg:text-[20px] md:text-[17px] tracking-[0.5px] text-[#000000] ">
          A Blog Newsletter Pop-Up is a small window that appears on a
            webpage, prompting visitors to subscribe to the blog's newsletter.
            It typically includes a short message, a form to input an email
            address, and a call-to-action button like "Subscribe" or "Join Now."
            This helps grow the blog's audience by encouraging readers to stay
            updated with new posts and content.
          </p>
        </div>
        <div className=" mt-10 flex flex-row justify-center items-center gap-4">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="
              border-[#AF313D] rounded-[30rem] border-[2px] md:h-[67px]
              h-[54px] md:w-[60%] w-[80%] pl-[25px] py-2 focus:outline-none 
              focus:ring-2 focus:ring-[#AF313D] md:text-[18px] text-[13px]
              placeholder:text-[13px] font-bold tracking-[2%] leading-[24px]
              placeholder:text-[#AF313D] placeholder:font-bold 
              md:placeholder:text-[18px] placeholder:tracking-[2%] 
              placeholder:leading-[24px]"
          />
          <button
             onClick={handleSubscribe}
            // disabled={submitting}
            className={`bg-[#AF313D] text-white rounded-full w-[130px] h-[54px] md:w-[166px] md:h-[67px] px-[36px] text-sm font-medium hover:bg-red-700 ${
              submitting ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <span className="body font-semibold md:text-[20px] text-[13px] leading-[24px] flex items-center justify-center md:tracking-[2px]">
              {submitting ? "Submitting..." : "Subscribe"}
            </span>
          </button>
        </div>
      </Modal>

      {/* Cards Section */}
      <div className="mt-10 px-4">
        {Object.keys(categorizedBlogs).map((category) => (
          <div key={category} className="mb-8">
            <h2 className="text-3xl font-bold text-[#AF313D] mb-4 body">{category}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {categorizedBlogs[category].map((blog) => (
                <Card key={blog._id} blog={blog} />
              ))}
            </div>
          </div>
        ))}
 
      </div>
    </div>
  );
};

export default Blog;
